import React, { Component } from 'react'
import VideoPlayer from '../../components/VideoPlayer'
import FontAwesome from 'react-fontawesome'
import './styles.css'

export default class IntroPage extends Component {
    constructor(props) {
        super(props)
        this.handleOnVideoEnd = this.handleOnVideoEnd.bind(this);
        this.state = {showVideo:false}
    }

    handleOnVideoEnd() {
        this.create()
    }

    play() {
        this.videoPlayer.player.play()
        this.setState( { showVideo: true })
    }

    create() {
        console.log('video is done.')
        window.location.replace(process.env.PUBLIC_URL + '/create' || '/create');
    }
    render() {
        const rootPath = process.env.PUBLIC_URL + '/' || '/'
        const videoJsOptions = {
            controls: true,
            sources: [{
              src: rootPath + 'video/PaperFoldInstructions.mp4',
              type: 'video/mp4'
            }]
          }
        var videoStyle = { display: (this.state.showVideo) ? 'block':'none'}
        return (
            <div>
                <div style={videoStyle}>
                    <VideoPlayer ref={el => this.videoPlayer = el} options={videoJsOptions} onVideoEnd={this.handleOnVideoEnd} />
                </div>
                <ul className='intro-container'>
                    <li className="flake-container flake-info">
                        <div className="flake">
                            <h3><span>Create a Snowflake.</span> Make a snowflake, add it to the gallery and share it with your friends and family.</h3>
                        </div>
                        <div className="flake-message">
                            <p></p>
                        </div>
                    </li>
                    <li className="flake-container flake-start">
                        <div className="flake">
                            <button onClick={this.play.bind(this)}><FontAwesome name="play" />Watch Tutorial</button>
                            <button onClick={this.create.bind(this)}><FontAwesome name="scissors" />Start Creating</button>
                        </div>
                        <div className="flake-message">
                            <p></p>
                        </div>
                    </li>
                    <li className="flake-container">
                        <div className="flake">
                            <img src={rootPath + "images/janis-flake.jpg"} alt="snowflake" />
                        </div>
                        <div className="flake-message janis">
                            <p>Merry Christmas!  Best wishes for a new year filled with good people, projects, and prosperity with good fun along the way!    Janis Fairchild</p>
                        </div>
                    </li>
                    <li className="flake-container">
                        <div className="flake">
                            <img src={rootPath + "images/t-flake.jpg"} alt="snowflake" />
                        </div>
                        <div className="flake-message t">
                            <p>Merry Christmas and a Happy New Year! - Tom</p>
                        </div>
                    </li>
                    <li className="flake-container">
                        <div className="flake">
                            <img src={rootPath + "images/d-flake.jpg"} alt="snowflake" />
                        </div>
                        <div className="flake-message d">
                            <p>Here is to all finding Hope and joy in the holiday Season and a blessed 2018! - Drew</p>
                        </div>
                    </li>
                    <li className="flake-container">
                        <div className="flake">
                            <img src={rootPath + "images/v-flake.jpg"} alt="snowflake" />
                        </div>
                        <div className="flake-message v">
                            <p>Thank You For Another Great Year! Merry Christmas And Best Wishes For 2018, Veronica!</p>
                        </div>
                    </li>
                    <li className="flake-container">
                        <div className="flake">
                            <img src={rootPath + "images/s-flake.jpg"} alt="snowflake" />
                        </div>
                        <div className="flake-message s">
                            <p>Merry Christmas and have a Happy New Year! -Stephanie</p>
                        </div>
                    </li>
                    <li className="flake-container">
                        <div className="flake">
                            <img src={rootPath + "images/r-flake.jpg"} alt="snowflake" />
                        </div>
                        <div className="flake-message r">
                            <p>Have a Merry Christmas! - Ryan</p>
                        </div>
                    </li>
                    <li className="flake-container">
                        <div className="flake">
                            <img src={rootPath + "images/a-flake.jpg"} alt="snowflake" />
                        </div>
                        <div className="flake-message a">
                            <p>Merry Christmas, Adam</p>
                        </div>
                    </li>
                    <li className="flake-container">
                        <div className="flake">
                            <img src={rootPath + "images/b-flake.jpg"} alt="snowflake" />
                        </div>
                        <div className="flake-message b">
                            <p>Merry Christmas and a Happy New Year! - Boomer</p>
                        </div>
                    </li>
                    <li className="flake-container">
                        <div className="flake">
                            <img src={rootPath + "images/j-flake.jpg"} alt="snowflake" />
                        </div>
                        <div className="flake-message j">
                            <p>Santa said you're not getting any presents, but I'll share mine with you. Happy Holidays! - Jason</p>
                        </div>
                    </li>
                    <li className="flake-container">
                        <div className="flake">
                            <img src={rootPath + "images/jj-flake.jpg"} alt="snowflake" />
                        </div>
                        <div className="flake-message jj">
                            <p>Happy Holidays! - Jacob</p>
                        </div>
                    </li>
                </ul>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/IntroPage/index.js